import { graphql } from 'gatsby';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import ProtezioneZappyrent from '../components/ProtezioneZappyrent';
import Seo from '../components/Seo';
import TextPageLandlord from '../components/TextPageLandlord';

const contentIndexItems = [
  {
    id: 'cose-protezione-zappyrent',
    text: `Cos'é Protezione Zappyrent?`,
  },
  {
    id: 'la-migliore-garanzia',
    text: 'La migliore garanzia sugli affitti',
  },
  {
    id: 'come-affittare-casa',
    text: 'Come affittare casa con Zappyrent',
  },
  {
    id: 'perche-affittare-casa',
    text: 'Perché affittare casa con Zappyrent?',
  },
  {
    id: 'zappyrent-tutela-inquilino',
    text: `Zappyrent tutela anche l'inquilino`,
  },
  { id: 'faq', text: 'FAQ' },
];

const ProtezioneZappyrentPage = (): JSX.Element => {
  const { t } = useTranslation('product');
  const [contentIndexContextValue, setContentIndexContextValue] = useState([]);

  return (
    <>
      <Seo
        canonical="/it/protezione-zappyrent"
        hreflang="it"
        title="Protezione Zappyrent"
        description="Scopri come funziona Protezione Zappyrent e tutti i vantaggi!"
        ogImageUrl={`${process.env.GATSBY_CDN_URL}/opengraph/zappyrent-logo-purple-500x500.png`}
        ogImageHeight="500"
        ogImageWidth="500"
        schemaOrg={`
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "${t('product:protezioneFaqQ1')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${t('product:protezioneFaqA1')}"
              }
            },
            {
              "@type": "Question",
              "name": "${t('product:protezioneFaqQ2')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${t('product:protezioneFaqA2')}"
              }
            },
            {
              "@type": "Question",
              "name": "${t('product:protezioneFaqQ3')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${t('product:protezioneFaqA3')}"
              }
            },
            {
              "@type": "Question",
              "name": "${t('product:protezioneFaqQ4')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${t('product:protezioneFaqA4')}"
              }
            },
            {
              "@type": "Question",
              "name": "${t('product:protezioneFaqQ5')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${t('product:protezioneFaqA5')}"
              }
            },
            {
              "@type": "Question",
              "name": "${t('product:protezioneFaqQ6')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${t('product:protezioneFaqA6')}"
              }
            },
            {
              "@type": "Question",
              "name": "${t('product:protezioneFaqQ7')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${t('product:protezioneFaqA7')}"
              }
            },
            {
              "@type": "Question",
              "name": "${t('product:protezioneFaqQ8')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${t('product:protezioneFaqA8')}"
              }
            },
            {
              "@type": "Question",
              "name": "${t('product:protezioneFaqQ9')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${t('product:protezioneFaqA9')}"
              }
            },
            {
              "@type": "Question",
              "name": "${t('product:protezioneFaqQ10')}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${t('product:protezioneFaqA10')}"
              }
            }
          ]
        }
        `}
      />
      <TextPageLandlord
        articleId="protezione-zappyrent"
        h1Text={
          <Trans
            i18nKey="protezioneZappyrentHeading"
            t={t}
            components={{ span: <span /> }}
          />
        }
        h2Text={`${t('product:protezioneZappyrentSubHeading')}`}
        contentIndexContextValue={contentIndexContextValue}
        contentIndexItems={contentIndexItems}
      >
        <ProtezioneZappyrent
          updateContext={value => setContentIndexContextValue(value.current)}
        />
      </TextPageLandlord>
    </>
  );
};

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default ProtezioneZappyrentPage;
